import * as React from 'react'
import {
	FaCoins,
	FaCommentsDollar,
	FaHandshake,
	FaHeadset,
	FaMoneyBillWave,
	FaPiggyBank,
	FaUniversity,
	FaUserSecret
} from 'react-icons/all'

const FeaturesSection = () => (
	<section id='features-section' className='bg-yellow-400 flex flex-wrap'>
		{features.map(feat => (
			<div
				key={feat.description}
				className='p-12 w-full sm:w-1/2 lg:w-1/4'
			>
				<figure className='flex flex-col items-center h-full'>
					{feat.icon}
					<figcaption className='text-center'>
						{feat.description}
					</figcaption>
				</figure>
			</div>
		))}
	</section>
)

interface Feature {
	readonly icon: React.ReactNode
	readonly description: string
}
const features: Feature[] = [
	{
		icon: <FaCoins className='mb-6' size={48} />,
		description: 'Cash Account Free Bonus 10-30%'
	},
	{
		icon: <FaPiggyBank className='mb-6' size={48} />,
		description: 'Credit Account Weekly 5-20% Lost Rebate'
	},
	{
		icon: <FaHandshake className='mb-6' size={48} />,
		description: 'Reliable in winning payment'
	},
	{
		icon: <FaCommentsDollar className='mb-6' size={48} />,
		description: 'Settlement Fast, Withdraw Fast, Transfer Fast'
	},
	{
		icon: <FaUniversity className='mb-6' size={48} />,
		description:
			'Support To Direct Deposits/Withdrawals Through Singapore Bank'
	},
	{
		icon: <FaMoneyBillWave className='mb-6' size={48} />,
		description: 'Cash Account 1 week 1 time 20% Free Bonus'
	},
	{
		icon: <FaHeadset className='mb-6' size={48} />,
		description: 'Good Customer Supports'
	},
	{
		icon: <FaUserSecret className='mb-6' size={48} />,
		description:
			'Clients Information Will Be Kept In The Strictest Confidence'
	}
]

export default FeaturesSection
